import { PopperTooltip } from './PopperTooltip';
import type { BasePopperTooltipProps, RedesignPopperTooltipProps } from './types';
import { UiRedesignPopperTooltip } from './UiRedesignPopperTooltip';

const Tooltip = (props: BasePopperTooltipProps | RedesignPopperTooltipProps) => {
  if (props.supportsNewTooltipDesign) {
    return <UiRedesignPopperTooltip {...(props as RedesignPopperTooltipProps)} />;
  }

  return <PopperTooltip {...props} />;
};

export default Tooltip;
